import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["startDate"],
            "sorts": ["desc"]
        },
        "filters":[
            // "id","=",2402
        ],
        "pageNo": 1,
        "itemsPerPage": 10
    },
};

const trainingCalendarSlice = createSlice({
    name: 'trainingCalendar',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = trainingCalendarSlice.actions;

export default trainingCalendarSlice.reducer;
